import { liteClient } from 'algoliasearch/lite';
import { algoliasearch } from 'algoliasearch';

export const searchClient = liteClient(
  window.ALGOLIA_APPLICATION_ID,
  window.ALGOLIA_SEARCH_KEY
);

export const client = algoliasearch(
  window.ALGOLIA_APPLICATION_ID,
  window.ALGOLIA_SEARCH_KEY
);
